"use strict";
import jQuery from 'jquery';
import { initGlossary } from './modules/glossary.js';
import { initFundingOptions } from './modules/funding-options.js';
import { getAssetsBase } from './modules/assets-base.js';


(function ($) {

  // Glossary
  initGlossary($);

  // Module 2
  initFundingOptions({
    dataUrl: `${getAssetsBase()}data/sb-healthcare-hub-module2.json`,
    target: '#funding-cards'
  });

  // Floating label + combobox behavior
  $(".combobox-list input").each(function () {
    const $input = $(this);
    const $combobox = $input.closest(".combobox-list");
    const $listbox = $combobox.find('[role="listbox"]');
    const $button = $combobox.find("button");
    const $options = $listbox.find("li");

      // DISABLE BROWSER AUTOCOMPLETE
      $input.attr("autocomplete", "off");

    let focusedIndex = -1;
    let selectedIndex = -1;

    function updateStateClass(selectedText) {
      const lowerText = selectedText.toLowerCase().replace(/\s+/g, "-");
      const $stateCombo = $(".elearning-state-combobox");
      $stateCombo.removeClass(function (index, className) {
        return (className.match(/(^|\s)state-\S+/g) || []).join(" ");
      });
      $stateCombo.addClass("state-" + lowerText);
      
      // Hide the state resources QA section when a state is selected
      $('.state-resources-qa').addClass('d-none');
      $('.all-states-info').removeClass('d-none');  
    }

    function syncFloating() {
      const hasValue = $input.val().trim() !== "";
      const hasSelected = $listbox.find('[aria-selected="true"]').length > 0;
      if (hasValue || $input.is(":focus") || hasSelected) {
        $combobox.addClass("is-floating");
      } else {
        $combobox.removeClass("is-floating");
      }
    }

    function openDropdown() {
      $listbox.show();
      $input.attr("aria-expanded", "true");
      $button.attr("aria-expanded", "true");
    }

    function closeDropdown() {
      $listbox.hide();
      $input.attr("aria-expanded", "false");
      $button.attr("aria-expanded", "false");
      focusedIndex = -1;
      $input.removeAttr("aria-activedescendant");
      $options.removeClass("highlighted");
      syncFloating();
    }

    function highlightOption() {
      $options.removeClass("highlighted");
      if (focusedIndex >= 0 && focusedIndex < $options.length) {
        const $option = $options.eq(focusedIndex);
        $option.addClass("highlighted");
        $input.attr("aria-activedescendant", $option.attr("id"));
    
        // Ensure visible in scroll (fixed version)
        const listboxTop = $listbox.scrollTop();
        const optionTop = $option[0].offsetTop;
        const optionBottom = optionTop + $option.outerHeight();
        const listboxHeight = $listbox.innerHeight();
    
        if (optionBottom > listboxTop + listboxHeight) {
          // Scroll down so option is at bottom
          $listbox.scrollTop(optionBottom - listboxHeight);
        } else if (optionTop < listboxTop) {
          // Scroll up so option is at top
          $listbox.scrollTop(optionTop);
        }
      } else {
        $input.removeAttr("aria-activedescendant");
      }
    }
    

    function commitSelection(index) {
      if (index < 0 || index >= $options.length) return;
      const $opt = $options.eq(index);
      const text = $opt.text();
      $options.attr("aria-selected", "false");
      $opt.attr("aria-selected", "true");
      selectedIndex = index;
      $input.val(text);
      updateStateClass(text);
      syncFloating();
    }

    // Pre-select if initial value matches an option
    (function initSelectedFromValue() {
      const current = $input.val().trim().toLowerCase();
      if (!current) return;
      $options.each(function (i) {
        if ($(this).text().trim().toLowerCase() === current) {
          commitSelection(i);
          return false;
        }
      });
    })();

    $input.on("click", function (e) {
      e.preventDefault();
      if ($input.attr("aria-expanded") === "true") {
        closeDropdown();
      } else {
        openDropdown();
      }
    });

    $options.on("click", function () {
      commitSelection($options.index(this));
      closeDropdown();
    });

    // Keyboard navigation
    $input.on("keydown", function (e) {
      const isExpanded = $input.attr("aria-expanded") === "true";
      const $visibleOptions = $options.filter(":visible");
    
      switch (e.key) {
        case "ArrowDown":
          e.preventDefault();
          if (!isExpanded) {
            openDropdown();
            focusedIndex = selectedIndex >= 0 ? $visibleOptions.index($options.eq(selectedIndex)) : 0;
          } else {
            if ($visibleOptions.length === 0) break;
            focusedIndex = (focusedIndex + 1) % $visibleOptions.length;
          }
          highlightVisibleOption($visibleOptions);
          break;
    
        case "ArrowUp":
          e.preventDefault();
          if (!isExpanded) {
            openDropdown();
            focusedIndex = selectedIndex >= 0 ? $visibleOptions.index($options.eq(selectedIndex)) : $visibleOptions.length - 1;
          } else {
            if ($visibleOptions.length === 0) break;
            focusedIndex = (focusedIndex - 1 + $visibleOptions.length) % $visibleOptions.length;
          }
          highlightVisibleOption($visibleOptions);
          break;
    
        case "Enter":
        case " ":
          e.preventDefault();
          if (!isExpanded) {
            openDropdown();
            focusedIndex = selectedIndex >= 0 ? $visibleOptions.index($options.eq(selectedIndex)) : 0;
            highlightVisibleOption($visibleOptions);
          } else if (focusedIndex >= 0 && $visibleOptions.length > 0) {
            const realIndex = $options.index($visibleOptions.eq(focusedIndex));
            commitSelection(realIndex);
            closeDropdown();
          }
          break;
    
        case "Escape":
        case "Tab":
          closeDropdown();
          break;
      }
    });
    
    // Helper function to highlight only visible options
    function highlightVisibleOption($visibleOptions) {
      $options.removeClass("highlighted");
      if (focusedIndex >= 0 && focusedIndex < $visibleOptions.length) {
        const $option = $visibleOptions.eq(focusedIndex);
        $option.addClass("highlighted");
        $input.attr("aria-activedescendant", $option.attr("id"));
    
        const listboxTop = $listbox.scrollTop();
        const optionTop = $option[0].offsetTop;
        const optionBottom = optionTop + $option.outerHeight();
        const listboxHeight = $listbox.innerHeight();
    
        if (optionBottom > listboxTop + listboxHeight) {
          $listbox.scrollTop(optionBottom - listboxHeight);
        } else if (optionTop < listboxTop) {
          $listbox.scrollTop(optionTop);
        }
      } else {
        $input.removeAttr("aria-activedescendant");
      }
    }
    

    $(document).on("mousedown", function (e) {
      if (!$combobox.is(e.target) && $combobox.has(e.target).length === 0) {
        closeDropdown();
      }
    });

    $input.on("input", function () {
      const search = $input.val().toLowerCase().trim();
      let hasMatch = false;

      if (
        selectedIndex >= 0 &&
        $options.eq(selectedIndex).text().trim().toLowerCase() !== search
      ) {
        $options.eq(selectedIndex).attr("aria-selected", "false");
        selectedIndex = -1;
      }

      $options.each(function () {
        const $opt = $(this);
        const text = $opt.text().toLowerCase();
        const match = text.indexOf(search) === 0;
        $opt.toggle(match || search === "");
        if (match) hasMatch = true;
      });

      if (search === "") {
        closeDropdown();
      } else if (hasMatch) {
        openDropdown();
      } else {
        closeDropdown();
      }

      focusedIndex = -1;
      syncFloating();
    });

    $input.on("focus blur", syncFloating);
    syncFloating();
  });

  // Load glossary data once and cache it
  let glossaryData = [];
  $.getJSON(`${getAssetsBase()}data/glossary.json`, function (data) {
    console.log("Loaded glossary data:", data);
    glossaryData = data;
  });

  const glossaryButtons = document.querySelectorAll("[data-bs-title]");

  glossaryButtons.forEach((btn) => {
    new bootstrap.Tooltip(btn);
  });
  

  //===========================================================
  //BIOS
  const bios = $("section.bios");
  if (bios.length > 0) {
    const filters = bios.find(".filter");
    let activeFilter = "all";
    filters.on("click", function () {
      filters.removeAttr("aria-pressed");
      $(this).attr("aria-pressed", "true");
      setTimeout(updateTiles, 100);
    });

    function updateTiles() {
      let activeFilters = [],
        bioTiles = bios.find(".bio-tile");
      bios.find(".filter").map((index, item) => {
        console.log(
          "found a pressed item",
          $(item).attr("aria-pressed"),
          $(item)
        );
        if ($(item).attr("aria-pressed") === "true") {
          activeFilters.push($(item).attr("data-filter-tag"));
        }
      });

      console.log("active filters", activeFilters);

      if (activeFilters.includes("all")) {
        var btnText = $(
          '.filter-dropdown .dropdown-item[data-filter-tag="all"]'
        ).text();
        $(".filter-dropdown .dropdown-toggle").html(btnText);
        bioTiles.removeClass("d-none");
      } else {
        bioTiles.addClass("d-none");
        activeFilters.map((filter) => {
          var btnText = $(
            '.filter-dropdown .dropdown-item[data-filter-tag="' + filter + '"]'
          ).text();
          $(".filter-dropdown .dropdown-toggle").html(btnText);
          bioTiles.map((index, tile) => {
            // console.log(
            //   "Tile tags:",
            //   $(tile).attr("data-filter-tags"),
            //   "target tag:",
            //   filter
            // );
            if ($(tile).attr("data-filter-tags").indexOf(filter) > -1) {
              $(tile).removeClass("d-none");
            }
          });
        });
      }
      setTimeout(function () {
        $(".bio-tiles .bio-tile a:visible")[0].focus();
      }, 100);
    }
  }

  document.tnsAda = {
    init: function (params) {
      //if the container element is not present. do nothing and exit.
      if ($(params.container).length < 1) {
        return;
      }
      var orig = this;

      // Definte options for ADA functions
      var opt = {
        nav: params.nav, // Create a custom ADA bullet nav?
        controls: params.controls, // Create custom ADA prev and next buttons?
        reverseNextPrev: params.reverseNextPrev, // Reverse the action of the next and previous buttons?
        navText: params.navText || '<span aria-hidden="true">•</span>',
        controlsText: params.controlsText || [
          '<span aria-hidden="true"><</span><span class="sr-only">Previous Slide</span>',
          '<span aria-hidden="true">></span><span class="sr-only">Next Slide</span>',
        ],
      };

      // Prepare params object for initialization
      params.nav = false;
      params.controls = false;
      delete params.navText;
      delete params.controlsText;
      delete params.reverseNextPrev;

      // Initialize the slider and store it in our opt object.
      opt.slider = tns(params);

      if (opt.controls) {
        orig.addControls(opt);
      }
      if (opt.nav) {
        orig.addNav(opt);
      }
      orig.oneTimeFixes(opt);
    },
    oneTimeFixes: function (opt) {
      var orig = this,
        slider = opt.slider,
        info = slider.getInfo(),
        inner = $(info.container).parents(".tns-inner"),
        outer = $(info.container).parents(".tns-outer"),
        uiEnabled = true;

      // Add role attribute to the slides
      inner.find(".tns-item").attr("role", "group");

      // Remove non-compliant live region
      outer
        .find(".tns-liveregion")
        .removeAttr("aria-live")
        .removeAttr("aria-atomic")
        .attr("aria-hidden", "true")
        .hide();

      // Add carousel instructions
      outer.prepend(
        '<p class="sr-only tns-custom-instructions">This is a carousel. Use Next and Previous buttons to navigate, or jump to a slide with the slide dots.</p>'
      );

      // Hide controls if all items are displayed at once
      $(window).on("resize", function () {
        orig.updateActive("", opt);
        setTimeout(() => {
          if (info.slideCount > slider.getInfo().items) {
            toggleUi("on");
          } else {
            toggleUi("off");
          }
        }, 200);
      });
      $(window).trigger("resize");
      function toggleUi(dir) {
        if (dir == "off") {
          outer
            .find(
              ".tns-custom-controls, .tns-custom-nav, .tns-custom-instructions"
            )
            .hide()
            .attr("aria-hidden", "true");
          orig.updateActive(0, opt);
          uiEnabled = false;
        }
        if (dir == "on") {
          outer
            .find(
              ".tns-custom-controls, .tns-custom-nav, .tns-custom-instructions"
            )
            .show()
            .removeAttr("aria-hidden");
          uiEnabled = true;
        }
      }

      // bind function to event
      slider.events.on("transitionEnd", function () {
        orig.updateActive("", opt);
      });
    },
    addControls: function (opt) {
      var orig = this,
        slider = opt.slider,
        info = slider.getInfo(),
        inner = $(info.container).parents(".tns-inner"),
        sliderKey = ($(info.container).attr("id") || "tns").replace(/-/g, "_").slice(0, 10);
      // Add prev/next buttons and events
      // Note: TNS sliders interpretation of "next and previous" is a bit conterintuitive.
      //       I swapped them by default. The reverseNextPrev flag allows you to switch back.
      if (opt.reverseNextPrev) {
        inner.prepend(
          '<button type="button" class="tns-custom-controls tns-custom-next chaseanalytics-track-link" data-pt-name="' +
            sliderKey +
            '_next">' +
            opt.controlsText[0] +
            "</button>"
        );
        inner.append(
          '<button type="button" class="tns-custom-controls tns-custom-prev chaseanalytics-track-link" data-pt-name="' +
            sliderKey +
            '_prev">' +
            opt.controlsText[1] +
            "</button>"
        );
      } else {
        inner.prepend(
          '<button type="button" class="tns-custom-controls tns-custom-prev tns-custom-reverse chaseanalytics-track-link" data-pt-name="' +
            sliderKey +
            '_prev">' +
            opt.controlsText[0] +
            "</button>"
        );
        inner.append(
          '<button type="button" class="tns-custom-controls tns-custom-next tns-custom-reverse chaseanalytics-track-link" data-pt-name="' +
            sliderKey +
            '_next">' +
            opt.controlsText[1] +
            "</button>"
        );
      }
      inner.find(".tns-custom-next").on("click", function () {
        orig.updateActive("next", opt);
      });
      inner.find(".tns-custom-prev").on("click", function () {
        orig.updateActive("prev", opt);
      });
    },
    addNav: function (opt) {
      var orig = this,
        slider = opt.slider,
        info = slider.getInfo(),
        inner = $(info.container).parents(".tns-inner"),
        sliderKey = ($(info.container).attr("id") || "tns").replace(/-/g, "_").slice(0, 10);

      // Add bullet nav and events
      var newNav = '<ul class="tns-custom-nav">';
      for (let i = 0; i < info.slideCount; i++) {
        newNav =
          newNav +
          '<li><button type="button" class="tns-custom-nav-item chaseanalytics-track-link" data-tns-custom-nav-id="' +
          i +
          '" aria-label="Go to slide ' +
          (i + 1) +
          '" data-pt-name="' +
          sliderKey +
          "_dot_" +
          i +
          '">' +
          opt.navText +
          "</button></li>";
      }
      inner.append(newNav + "</ul>");
      inner.find("[data-tns-custom-nav-id]").on("click", function () {
        var target = $(this).attr("data-tns-custom-nav-id");
        orig.updateActive(target, opt);
      });
    },
    updateActive: function (target, opt) {
      var focusable = "[href], button, input, select, textarea",
        slider = opt.slider,
        info = slider.getInfo(),
        inner = $(info.container).parents(".tns-inner");

      // Navigate to the target slide
      if (target.length > 0) {
        slider.goTo(target);
      }

      // Modify slides and bullet nav to reflect the new active slide state
      setTimeout(function () {
        var newInfo = slider.getInfo();

        // Make all focusable elements in hidden slides not focusable and update the aria properties of all slides
        inner
          .find(".tns-item")
          .removeAttr("aria-label")
          .attr("tabindex", "-1")
          .attr("aria-hidden", "true")
          .find(focusable)
          .attr("tabindex", "-1");
        if (info.slideCount > slider.getInfo().items) {
          for (let i = newInfo.index; i < newInfo.items + newInfo.index; i++) {
            inner
              .find(".tns-item")
              .eq(i)
              .removeAttr("tabindex")
              .removeAttr("aria-hidden")
              .attr(
                "aria-label",
                "Slide " +
                  (i - newInfo.index + newInfo.displayIndex) +
                  " of " +
                  info.slideCount
              )
              .find(focusable)
              .removeAttr("tabindex");
          }
        } else {
          for (let i = newInfo.index; i < newInfo.items + newInfo.index; i++) {
            inner
              .find(".tns-item")
              .eq(i)
              .removeAttr("tabindex")
              .removeAttr("aria-hidden")
              .find(focusable)
              .removeAttr("tabindex");
          }
        }

        // Update the bullet nav to reflect the currently active slide.
        if (opt.nav) {
          var navBtns = inner.find("[data-tns-custom-nav-id]"),
            activeNavBtn = inner.find(
              '[data-tns-custom-nav-id="' + (newInfo.displayIndex - 1) + '"]'
            );
          navBtns.removeAttr("aria-current");
          activeNavBtn.attr("aria-current", "true");
        }
      }, 100);
    },
  };

  // Shuffle UL lists.   ul = ul dom element
  function ulShuffle(ul) {
    for (var i = ul.children.length; i >= 0; i--) {
      ul.appendChild(ul.children[(Math.random() * i) | 0]);
    }
  }

  if ($("#milestoneWrapper").length > 0) {
    // Blog - Featured Medium Articles.

    var sliderMilestone = document.tnsAda.init({
      container: "#milestoneWrapper",
      items: 1,
      center: false,
      loop: true,
      nav: true,
      swipeAngle: false,
      speed: 400,
      // "edgePadding": 50,
      gutter: 30,
      responsive: {
        728: {
          items: 2,
          gutter: 20,
        },
        992: {
          items: 3,
          // "edgePadding": 100,
        },
      },
    });
  }

  if ($("#carouselWrapper").length > 0) {
    // Blog - Featured Medium Articles.
    ulShuffle($("#carouselWrapper")[0]);
    var sliderCarousel = document.tnsAda.init({
      container: "#carouselWrapper",
      items: 1,
      center: false,
      loop: true,
      nav: true,
      swipeAngle: false,
      speed: 400,
    });
  }

  var myCollapsible = $("#collapseOne");
  $(myCollapsible).on("show.bs.collapse", function () {
    $("#loadMoreBtn").addClass("d-none");
    setTimeout(() => {
      $("#collapseOne").find("a").eq(0).focus();
    }, 200);
  });

  
  var myCollapsibleTwo = $("#collapseTwo");
  $(myCollapsibleTwo).on("shown.bs.collapse", function () {
    $("#loadMorePRBtn").addClass("d-none");
    $("#collapseTwo").find("a")[0].focus();
  });

  //===========================================================
  // SpeedBump for Exit Links
  // ===========================================================

  var speedbumpWhiteList = ["chase.com", "jpmorgan.com", "jpmorganchase.com", "morganhealth.com"];
  //Speedbump modal script
  $(document)
    .off("click.speedBumpModal")
    .on("click.speedBumpModal", function (e) {
      //get the clicked element
      var myTarget = $(e.target);
      //if that element is the child of an anchor, target the anchor instead
      if (myTarget.parents("a").length > 0) {
        myTarget = myTarget.parents("a");
      }
      var linkHref = myTarget.attr("href") || ""; // 'http://my.site.com/go'
      // only proceed if there is an href attribute with an external address in it.
      if (linkHref.indexOf("//") > -1 && !myTarget.is("#speedBumpProceed")) {
        var domain = linkHref.split("/")[2]; // 'my.site.com'
        var blocked = true;
        for (var i = 0; i < speedbumpWhiteList.length; i++) {
          // is the domain exactly equal the whitelisted value of 'site.com' or does it end with '.site.com'
          if (
            domain === speedbumpWhiteList[i] ||
            domain.endsWith("." + speedbumpWhiteList[i])
          ) {
            blocked = false;
          }
        }
        if (blocked) {
          e.preventDefault();
          var $speedBumpModal = $("#speedBumpModal");
          $speedBumpModal.modal("show");
          $speedBumpModal
            .off("hidden.bs.modal.speedBumpModal")
            .on("hidden.bs.modal.speedBumpModal", function () {
              $(myTarget).focus();
            });
          $speedBumpModal.find("#speedBumpProceed").attr("href", linkHref);
          $speedBumpModal
            .find("#speedBumpProceed")
            .off("click.speedBumpModal")
            .on("click.speedBumpModal", function () {
              $speedBumpModal.modal("hide");
            });
        }
      }
    });

  //Social Share
  var currentURL = window.location.href;

  // Share on LinkedIn
  $("#share-linkedin").click(function (e) {
    e.preventDefault();
    var linkedinShareURL =
      "https://www.linkedin.com/shareArticle?mini=true&url=" +
      encodeURIComponent(currentURL);
    
    // Show speedbump modal
    var $speedBumpModal = $("#speedBumpModal");
    $speedBumpModal.modal("show");
    $speedBumpModal
      .off("hidden.bs.modal.speedBumpModal")
      .on("hidden.bs.modal.speedBumpModal", function () {
        $(this).focus();
      });
    $speedBumpModal.find("#speedBumpProceed").attr("href", linkedinShareURL);
    $speedBumpModal
      .find("#speedBumpProceed")
      .off("click.speedBumpModal")
      .on("click.speedBumpModal", function () {
        $speedBumpModal.modal("hide");
      });
  });

  // Share on Twitter
  $("#share-twitter").click(function (e) {
    e.preventDefault();
    var twitterShareURL =
      "https://twitter.com/intent/tweet?url=" + encodeURIComponent(currentURL);
    
    // Show speedbump modal
    var $speedBumpModal = $("#speedBumpModal");
    $speedBumpModal.modal("show");
    $speedBumpModal
      .off("hidden.bs.modal.speedBumpModal")
      .on("hidden.bs.modal.speedBumpModal", function () {
        $(this).focus();
      });
    $speedBumpModal.find("#speedBumpProceed").attr("href", twitterShareURL);
    $speedBumpModal
      .find("#speedBumpProceed")
      .off("click.speedBumpModal")
      .on("click.speedBumpModal", function () {
        $speedBumpModal.modal("hide");
      });
  });

  // Copy Link
  $("#copy-link").click(function () {
    var tempInput = $("<input>");
    $("body").append(tempInput);
    tempInput.val(currentURL).select();
    document.execCommand("copy");
    tempInput.remove();

    var popupText = $("#popup-text");
    popupText.addClass("show-popup");
    popupText.text("Link copied to clipboard!");

    setTimeout(function () {
      popupText.removeClass("show-popup");
    }, 2000);
  });

  function formSubmissionStatus(url_parameter_value) {
    switch (url_parameter_value) {
      case "error":
        $("section.messages .alert.d-none").removeClass("d-none");
        break;
      default:
        console.log("Unhandled form submission status type.");
        break;
    }
  }

  let status = new URLSearchParams(window.location.search).get("status");
  formSubmissionStatus(status);

  //navbar fixes
  // setTimeout(function () {
  //   var collapses = $("li.nav-item ul");
  //   console.log("collapses", collapses);
  //   collapses.on("show.bs.collapse", function () {
  //     console.log("showing bs");
  //   });
  //   collapses.map((index, item) => {
  //     item.addEventListener("show.bs.collapse", function () {
  //       console.log("showing", item);
  //     });
  //     var thisCollapse = new bootstrap.Collapse(item);

  //     return null;
  //   });
  // }, 1000);
  // $("nav.navbar ul.submenu").on("show.bs.collapse", function () {
  //   console.log("showing");
  //   var otherCollapses = $(this)
  //     .parents(".nav-item")
  //     .siblings()
  //     .find(".collapse");
  //   console.log("other collap", otherCollapses);
  //   otherCollapses.map((index, item) => {
  //     var thisCollapse = new bootstrap.Collapse(item);
  //     thisCollapse.hide();
  //     return null;
  //   });
  // });
  // $("nav.navbar ul.collapse").on("hide.bs.collapse", function () {
  //   $("nav.navbar").removeClass("navbar-submenu");
  // });

  // useing the selector '.nav-item ul' target the bootstrap 5.3 collapse elements and add an event listener that will close all other collases when one is opened.
// Delegate to each navbar separately
$('nav.navbar')
  .on('show.bs.collapse', '.nav-item .submenuWrapper', function () {
    const $submenu = $(this);
    const $nav = $submenu.closest('nav.navbar');

    // Close ONLY siblings inside this navbar
    $nav.find('.nav-item .submenuWrapper')
      .not(this)
      .collapse('hide')
      .find('ul')
      .hide();

    // Style only this navbar
    $nav.addClass('navbar-submenu');

    // ===== Outside-click closer (scoped to THIS submenu) =====
    // Try to find the button that opened this submenu (supports Bootstrap 4/5 attrs)
    const id = this.id;
    const $toggle = id
      ? $nav.find(
          `[data-bs-toggle="collapse"][data-bs-target="#${id}"], ` +
          `[data-toggle="collapse"][data-target="#${id}"]`
        )
      : $();

    // Hang hub dropdown from the bottom of the blue bar (not mid-link)
    if ($nav.is('#elearning-sub-nav') && window.matchMedia('(min-width: 992px)').matches && $toggle.length) {
      const $item = $toggle.closest('.nav-item');
      const navRect = $nav[0].getBoundingClientRect();
      const itemRect = $item[0].getBoundingClientRect();
      this.style.setProperty('--submenu-top', `${navRect.bottom - itemRect.top}px`);
    }

    // After animation, re-show ULs in this navbar
    setTimeout(() => {
      $nav.find('.nav-item ul').show();
    }, 500);

    // Create a unique namespace so we can unbind cleanly on hide
    const ns = `.outside.${id || Math.random().toString(36).slice(2)}`;
    $submenu.data('outsideNs', ns);

    // Use mousedown for snappier response (click would also work)
    $(document).on('mousedown' + ns, function (ev) {
      const $t = $(ev.target);

      // If the click is inside the submenu, ignore
      if ($t.closest($submenu).length) return;

      // If the click is the toggle itself (or inside it), ignore
      if ($toggle.length && ($t.is($toggle) || $t.closest($toggle).length)) return;

      // Otherwise, close THIS submenu
      if ($toggle.length) {
        // Prefer triggering the toggle so aria-expanded stays in sync
        $toggle.trigger('click');
      } else {
        // Fallback: hide directly
        $submenu.collapse('hide');
      }
    });
  })
  .on('hide.bs.collapse', '.nav-item .submenuWrapper', function () {
    const $submenu = $(this);
    const $nav = $submenu.closest('nav.navbar');

    // If no submenu is open in THIS navbar, remove the class
    const anyOpen = $nav.find('.nav-item .submenuWrapper.show').not(this).length > 0;
    if (!anyOpen) {
      $nav.removeClass('navbar-submenu');
    }

    // Clear hub dropdown offset
    this.style.removeProperty('--submenu-top');

    // Remove the outside-click handler for THIS submenu
    const ns = $submenu.data('outsideNs');
    if (ns) {
      $(document).off('mousedown' + ns);
      $submenu.removeData('outsideNs');
    }
  });

  // Mobile burger menu: focus trap + keep collapsed submenu links out of tab order
  (function initMobileHubNavA11y() {
    const $hubNav = $('#elearning-sub-nav');
    const $menuPanel = $('#subNavbarSupportedContent');
    const $menuToggler = $hubNav.find('.navbar-toggler');
    const MOBILE_HUB_NAV_MQ = window.matchMedia('(max-width: 1399.98px)');
    const FOCUSABLE =
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    if (!$hubNav.length || !$menuPanel.length || !$menuToggler.length) {
      return;
    }

    function isMobileHubNav() {
      return MOBILE_HUB_NAV_MQ.matches;
    }

    function isInsideCollapsedSubmenu(el) {
      return $(el).closest('.submenuWrapper.collapse:not(.show)').length > 0;
    }

    function setTabManaged(el, removeFromTabOrder) {
      const node = el;

      if (removeFromTabOrder) {
        if (!node.dataset.hubNavTabManaged) {
          node.dataset.hubNavPrevTabindex = node.getAttribute('tabindex') ?? '';
          node.setAttribute('tabindex', '-1');
          node.dataset.hubNavTabManaged = 'true';
        }
        return;
      }

      if (!node.dataset.hubNavTabManaged) {
        return;
      }

      if (node.dataset.hubNavPrevTabindex === '') {
        node.removeAttribute('tabindex');
      } else {
        node.setAttribute('tabindex', node.dataset.hubNavPrevTabindex);
      }

      delete node.dataset.hubNavPrevTabindex;
      delete node.dataset.hubNavTabManaged;
    }

    function restoreAllTabManaged() {
      $hubNav.find('[data-hub-nav-tab-managed]').each(function () {
        setTabManaged(this, false);
      });
      $menuPanel.removeAttr('aria-hidden');
      $hubNav.find('.submenuWrapper[aria-hidden="true"]').removeAttr('aria-hidden');
    }

    function updateMobileHubNavTabOrder() {
      if (!isMobileHubNav()) {
        restoreAllTabManaged();
        return;
      }

      const menuOpen = $menuPanel.hasClass('show');

      $menuPanel.find(FOCUSABLE).each(function () {
        const removeFromTabOrder =
          !menuOpen || isInsideCollapsedSubmenu(this);
        setTabManaged(this, removeFromTabOrder);
      });

      if (menuOpen) {
        $menuPanel.removeAttr('aria-hidden');
      } else {
        $menuPanel.attr('aria-hidden', 'true');
      }

      $hubNav.find('.submenuWrapper').each(function () {
        const $submenu = $(this);
        const submenuOpen = $submenu.hasClass('show') && menuOpen;

        if (submenuOpen) {
          $submenu.removeAttr('aria-hidden');
        } else {
          $submenu.attr('aria-hidden', 'true');
        }
      });
    }

    function getMobileMenuFocusables() {
      const focusables = [];

      if ($menuToggler.is(':visible')) {
        focusables.push($menuToggler[0]);
      }

      if (!$menuPanel.hasClass('show')) {
        return $(focusables);
      }

      $menuPanel.find(FOCUSABLE).each(function () {
        if (isInsideCollapsedSubmenu(this)) {
          return;
        }
        if (!$(this).is(':visible')) {
          return;
        }
        focusables.push(this);
      });

      return $(focusables);
    }

    function focusFirstMenuItem() {
      const $panelFocusables = $menuPanel
        .find(FOCUSABLE)
        .filter(function () {
          return !isInsideCollapsedSubmenu(this) && $(this).is(':visible');
        });

      if ($panelFocusables.length) {
        $panelFocusables.first().trigger('focus');
        return;
      }

      $menuToggler.trigger('focus');
    }

    function redirectFocusIntoMenu() {
      const active = document.activeElement;
      const $activeToggle = $(active).closest('.submenu-toggle');

      if ($activeToggle.length) {
        $activeToggle.trigger('focus');
        return;
      }

      const $focusables = getMobileMenuFocusables();
      if ($focusables.length) {
        $focusables.first().trigger('focus');
      }
    }

    function handleMenuTabKeydown(e) {
      if (e.key !== 'Tab' || !isMobileHubNav() || !$menuPanel.hasClass('show')) {
        return;
      }

      const $focusables = getMobileMenuFocusables();
      if (!$focusables.length) {
        return;
      }

      const first = $focusables[0];
      const last = $focusables[$focusables.length - 1];
      const active = document.activeElement;

      if (e.shiftKey) {
        if (active === first || !$hubNav[0].contains(active)) {
          e.preventDefault();
          last.focus();
        }
        return;
      }

      if (active === last || !$hubNav[0].contains(active)) {
        e.preventDefault();
        first.focus();
      }
    }

    function handleMenuEscape(e) {
      if (e.key !== 'Escape' || !isMobileHubNav() || !$menuPanel.hasClass('show')) {
        return;
      }

      e.preventDefault();
      $menuToggler.trigger('click');
    }

    function handleMenuFocusIn(e) {
      if (!isMobileHubNav() || !$menuPanel.hasClass('show')) {
        return;
      }

      const target = e.target;

      if ($(target).is('.submenu-toggle')) {
        return;
      }

      if ($hubNav[0].contains(target) && !isInsideCollapsedSubmenu(target)) {
        return;
      }

      redirectFocusIntoMenu();
    }

    function enableMobileMenuFocusTrap() {
      document.addEventListener('keydown', handleMenuTabKeydown);
      document.addEventListener('keydown', handleMenuEscape);
      document.addEventListener('focusin', handleMenuFocusIn);
    }

    function disableMobileMenuFocusTrap() {
      document.removeEventListener('keydown', handleMenuTabKeydown);
      document.removeEventListener('keydown', handleMenuEscape);
      document.removeEventListener('focusin', handleMenuFocusIn);
    }

    $menuPanel.on('shown.bs.collapse', function (e) {
      if (e.target !== this || !isMobileHubNav()) {
        return;
      }

      updateMobileHubNavTabOrder();
      enableMobileMenuFocusTrap();
      focusFirstMenuItem();
    });

    $menuPanel.on('hide.bs.collapse', function (e) {
      if (e.target !== this || !isMobileHubNav()) {
        return;
      }

      $hubNav.find('.submenuWrapper.show').collapse('hide');
    });

    $menuPanel.on('hidden.bs.collapse', function (e) {
      if (e.target !== this) {
        return;
      }

      disableMobileMenuFocusTrap();
      updateMobileHubNavTabOrder();
      $menuToggler.trigger('focus');
    });

    $hubNav.on('shown.bs.collapse hidden.bs.collapse', '.submenuWrapper', function (e) {
      if (!isMobileHubNav() || !$menuPanel.hasClass('show')) {
        updateMobileHubNavTabOrder();
        return;
      }

      updateMobileHubNavTabOrder();

      if (e.type === 'hidden') {
        const submenuId = this.id;
        const $toggle = $hubNav.find(`[data-bs-target="#${submenuId}"]`);
        if ($(document.activeElement).closest(this).length && $toggle.length) {
          $toggle.trigger('focus');
        }
      }
    });

    updateMobileHubNavTabOrder();

    MOBILE_HUB_NAV_MQ.addEventListener('change', function () {
      if (!isMobileHubNav()) {
        disableMobileMenuFocusTrap();
      }
      updateMobileHubNavTabOrder();
    });
  })();

  //ADA fix for modals
  //from https://app.clickup.com/24496962/v/dc/qbju2-11860/qbju2-11840
  $(".modal").on("show.bs.modal", function (event) {
    let $mymodal = $(this);
    $mymodal.parents().add($mymodal).siblings().attr("inert", "true");
  });

  $(".modal").on("hide.bs.modal", function (event) {
    let $mymodal = $(this);
    $mymodal.parents().add($mymodal).siblings().removeAttr("inert");
  });

  //Brightcove Videos - Modal Implementation
  const videoModal = $("#videoModal");
  const video1 = videoModal.find("#standard");
  const video2 = videoModal.find("#audio-desc");
  const videoThumbnail = $("#videoThumbnail");

  // Hide audio description video by default
  video2.hide();

  // Extract poster URL from video and set thumbnail
  $(document).ready(function() {
    const standardVideo = videoModal.find("#standard video");
    const posterUrl = standardVideo.attr("poster");
    if (posterUrl && videoThumbnail.length) {
      videoThumbnail.attr("src", posterUrl);
    }
  });

  // Pause a video container (stops playback when switching so both don't play)
  function pauseVideoInContainer($container) {
    if (!$container || !$container.length) return;
    const videoEl = $container.find("video")[0];
    if (videoEl) {
      if (typeof videoEl.pause === "function") {
        videoEl.pause();
      }
      if (window.videojs && videoEl.id) {
        try {
          const player = window.videojs.getPlayer(videoEl.id);
          if (player && typeof player.pause === "function") player.pause();
        } catch (e) {}
      }
      if (window.bc && window.bc.getPlayer) {
        try {
          const player = window.bc.getPlayer(videoEl.id);
          if (player && typeof player.pause === "function") player.pause();
        } catch (e) {}
        }
    }
  }

  // Force Safari to repaint after text change (avoids ghosting)
  function repaintAfterText(el) {
    var node = el && (el.jquery ? el[0] : el);
    if (node) {
      void node.offsetHeight;
      node.style.display = "none";
      node.offsetHeight; // force reflow before showing
      node.style.display = "";
      console.log("repainted", node);
    }
  }

  // Video switching functionality
  videoModal.find("#switchBtn").click(function () {
    var $btn = $(this);
    if (video1.is(":visible")) {
      pauseVideoInContainer(video1);
      video1.hide();
      video2.show();
      $btn.text("Standard Video");
      repaintAfterText($btn);
    } else {
      pauseVideoInContainer(video2);
      video1.show();
      video2.hide();
      $btn.text("Audio Description Video");
      repaintAfterText($btn);
    }
  });

  // Handle modal events
  videoModal.on("shown.bs.modal", function () {
    // Ensure videos are properly displayed when modal opens
    // Brightcove players should auto-initialize, but ensure visibility
    video1.show();
    video2.hide();
    var $switchBtn = videoModal.find("#switchBtn");
    $switchBtn.text("Audio Description Video");
    repaintAfterText($switchBtn);
  });

  videoModal.on("hidden.bs.modal", function () {
    // Pause all videos when modal closes
    const videos = videoModal.find("video");
    videos.each(function() {
      const video = this;
      if (video.pause) {
        video.pause();
      }
      // Also try to pause via Brightcove player API if available
      if (window.bc && window.bc.getPlayer) {
        try {
          const player = window.bc.getPlayer(video.id);
          if (player && player.pause) {
            player.pause();
          }
        } catch(e) {
          // Player may not be initialized yet
        }
      }
    });
  });
  //home hero randomizer
  var homeHero = $(".hero--home");
  if (homeHero.length > 0) {
    function getRandomInt(max) {
      return Math.floor(Math.random() * max);
    }
    var heroClasses = [
      "hero--home1",
      "hero--home2",
      "hero--home3",
      "hero--home4",
    ];
    homeHero.addClass(heroClasses[getRandomInt(heroClasses.length)]);
  }

  //audio player functionality

  function pauseAllOtherAudio(currentAudio) {
    const allAudio = document.querySelectorAll("audio.able-player");
    allAudio.forEach((audio) => {
      if (audio !== currentAudio && !audio.paused) {
        audio.pause();
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    // Hide transcripts by default on page load
    
    // Log able-duration text for each video on the page and update template duration elements
    function logAbleDurations() {
      const durationElements = document.querySelectorAll('.able-duration');
      //console.log('Found', durationElements.length, 'able-duration elements');
      
      durationElements.forEach((element, index) => {
        const fullDurationText = element.textContent.trim();
        console.log(`Video ${index + 1} full duration:`, fullDurationText);
        
        // Extract just the total duration (second portion after the slash)
        // Format is typically " / 3:20" - we want "3:20"
        let totalDuration = '';
        if (fullDurationText.includes(' / ')) {
          totalDuration = fullDurationText.split(' / ')[1] || '';
        } else if (fullDurationText.includes('/')) {
          totalDuration = fullDurationText.split('/')[1] || '';
        } else {
          totalDuration = fullDurationText;
        }
        totalDuration = totalDuration.trim();
        
        console.log(`Video ${index + 1} total duration:`, totalDuration);
        
        // Find the corresponding duration-text element in the template
        // We'll look for the closest audio-spotlight-wrapper and find its duration-text
        const audioWrapper = element.closest('.audio-spotlight-wrapper');
        if (audioWrapper) {
          const templateDurationElement = audioWrapper.querySelector('.duration-text');
          if (templateDurationElement) {
            // If total duration exists, is not empty, and is not "0:00", update the template
            if (totalDuration && totalDuration !== '' && totalDuration !== '0:00') {
              templateDurationElement.textContent = `Duration: ${totalDuration}`;
              templateDurationElement.style.display = 'block'; // Make sure it's visible
              console.log(`Updated template duration for video ${index + 1}:`, totalDuration);
            } else {
              // Hide the duration element if no valid duration is found or it's "0:00"
              templateDurationElement.style.display = 'none';
              console.log(`Hiding duration for video ${index + 1} - no valid duration found or duration is 0:00`);
            }
          }
        }
      });
    }
    
    // Call logAbleDurations after Able Player has initialized
    // Use a delay to ensure Able Player has generated the duration elements
    setTimeout(logAbleDurations, 1000);
    
    // Also try to log durations when Able Player elements are ready
    // Listen for when Able Player has finished initializing
    const checkForAbleElements = setInterval(() => {
      const durationElements = document.querySelectorAll('.able-duration');
      if (durationElements.length > 0) {
        console.log('Able Player elements detected, logging durations:');
        logAbleDurations();
        clearInterval(checkForAbleElements);
      }
    }, 500);
    
    // Clear the interval after 10 seconds to avoid infinite checking
    setTimeout(() => {
      clearInterval(checkForAbleElements);
    }, 10000);
    
    // Function to hide transcript in specific stepContent
    function hideTranscriptInStepContent(stepContentId) {
      const $stepContent = $(`#${stepContentId}`);
      const transcriptButton = $stepContent.find("div[role='button'].able-button-handler-transcript");
      
      if (transcriptButton.length > 0) {
        console.log('Found transcript button in', stepContentId);
        console.log('Button classes:', transcriptButton.attr('class'));
        console.log('Button has buttonOff class:', transcriptButton.hasClass('buttonOff'));
        
        // Check if transcript is currently visible (buttonOff means transcript is open)
        if (transcriptButton.hasClass('buttonOff')) {
          console.log('Attempting to click transcript button...');

          setTimeout(() => {

            transcriptButton[0].click();
            

            const clickEvent = new MouseEvent('click', {
              view: window,
              bubbles: true,
              cancelable: true
            });
            transcriptButton[0].dispatchEvent(clickEvent);

            transcriptButton[0].focus();
            
           
            setTimeout(() => {
              const enterEvent = new KeyboardEvent('keydown', {
                key: 'Enter',
                code: 'Enter',
                keyCode: 13,
                which: 13,
                bubbles: true
              });
              transcriptButton[0].dispatchEvent(enterEvent);
            }, 50);
            
            console.log('Multiple click methods attempted for transcript in', stepContentId);
          }, 100);
        } else {
          console.log('Transcript already hidden in', stepContentId);
        }
      } else {
        console.log('No transcript button found in', stepContentId);
      }
    }

    const collapses = document.querySelectorAll(".collapse");
    const collapseMap = [...collapses].reduce((acc, el) => {
      const collapseInstance = new bootstrap.Collapse(el, {
        toggle: false,
      });
      acc[el.id] = collapseInstance;
      return acc;
    }, {});

    const buttons = document.querySelectorAll(".audio-main-img-btn");

    buttons.forEach((btn) => {
      const index = btn.dataset.index;
      const collapseId = `stepContent-${index}`;
      const wrapper = btn.closest(".audio-spotlight-wrapper");
      const audioEl = wrapper.querySelector("audio");
      const collapse = collapseMap[collapseId];
      const collapseContent = wrapper.querySelector(`#${collapseId}`);

      // Initialize aria attributes correctly on page load
      btn.setAttribute("aria-controls", collapseId);
      btn.setAttribute("aria-expanded", "false");

      // Update aria-expanded when accordion opens
      collapseContent.addEventListener("shown.bs.collapse", () => {
        btn.setAttribute("aria-expanded", "true");
      });

      // Hide transcript when accordion is about to open
      collapseContent.addEventListener("show.bs.collapse", () => {
        console.log('Accordion about to open, hiding transcript in', collapseId);
        // hideTranscriptInStepContent(collapseId);
      });

      // Update aria-expanded when accordion closes
      collapseContent.addEventListener("hidden.bs.collapse", () => {
        btn.setAttribute("aria-expanded", "false");
      });

      btn.addEventListener("click", () => {
        const isExpanded = collapseContent.classList.contains("show");
        const isPlaying = !audioEl.paused && !audioEl.ended;

        // Pause all other audios
        pauseAllOtherAudio(audioEl);

        // Collapse other accordions
        Object.entries(collapseMap).forEach(([id, c]) => {
          if (id !== collapseId) c.hide();
        });

        // Remove playing state from all buttons
        document.querySelectorAll(".audio-main-img-btn").forEach((b) => {
          b.classList.remove("is-playing");
        });

        if (!isExpanded) {
          // Accordion is closed — open and play audio
          collapse.show();
          setTimeout(() => {
            audioEl.play();
          }, 350);
        } else {
          // Accordion is open — toggle play/pause
          if (isPlaying) {
            audioEl.pause();
          } else {
            audioEl.play();
          }
        }
      });

      // Sync button UI with audio state
      audioEl.addEventListener("play", () => {
        btn.classList.add("is-playing");
      });

      audioEl.addEventListener("pause", () => {
        btn.classList.remove("is-playing");
      });
    });

    // Dropdown toggle logic - only handles collapse, no audio playback
    document.querySelectorAll(".audio-dropdown-btn").forEach((btn) => {
      const index = btn.dataset.index;
      const collapseId = `stepContent-${index}`;

      const wrapper = btn.closest(".audio-spotlight-wrapper");
      const collapseContent = wrapper.querySelector(`#${collapseId}`);
      const collapse = collapseMap[collapseId];

      btn.setAttribute("aria-controls", collapseId);
      btn.setAttribute("aria-expanded", collapseContent.classList.contains("show") ? "true" : "false");

      // Keep duration text synced with collapse state
      collapseContent.addEventListener("shown.bs.collapse", () => {
        btn.setAttribute("aria-expanded", "true");
        const durationText = wrapper.querySelector(".duration-text");
        // if (durationText) durationText.classList.add("opacity-0", "invisible");
        // rotate dropdown button when open
        btn.classList.add("open");
      });
      collapseContent.addEventListener("hidden.bs.collapse", () => {
        btn.setAttribute("aria-expanded", "false");
        const durationText = wrapper.querySelector(".duration-text");
        // if (durationText) durationText.classList.remove("opacity-0", "invisible");
        // reset rotation when closed
        btn.classList.remove("open");
      });

      btn.addEventListener("click", () => {
        const isExpanded = collapseContent.classList.contains("show");

        // On every click: hide duration when opening; show when closing
        const durationText = wrapper.querySelector(".duration-text");
        if (!isExpanded) {
          // if (durationText) durationText.classList.add("opacity-0", "invisible");
          btn.classList.add("open");
        } else {
          // if (durationText) durationText.classList.remove("opacity-0", "invisible");
          btn.classList.remove("open");
        }

        // Close other accordions when opening this one
        Object.entries(collapseMap).forEach(([id, c]) => {
          if (id !== collapseId) c.hide();
        });

        // Toggle the collapse
        if (!isExpanded) {
          collapse.show();
        } else {
          collapse.hide();
        }
      });
    });
  });


// user feedback js (button-based, works with your SCSS)
$(function () {
  const slug = window.location.pathname;
  const ratingKey = `rating:${slug}`;
  const thankYouKey = `ratingThanked:${slug}`;

  const $ratingIntro = $(".rating-intro");
  const $ratingIntroThankYou = $(".rating-intro-thankyou");

  const $ratingListWrapper = $("#rating-list-wrapper");
  const $ratingListThankYou = $("#rating-list-thankyou");

  const $ul = $(".rating");
  const $buttons = $ul.find(".rating-btn");

  // Update selected stars (fills all stars left of value)
  function updateStars($ul, value) {
    $ul.data("rating", value);
    const $btns = $ul.find(".rating-btn");
  
    $btns.each(function (index) {
      const isActive = index < value;
  
      // Light up all stars to the left of the chosen one (visual only)
      $(this).toggleClass("selected", isActive);
  
      // Only the chosen one gets aria-pressed="true"
      if (index === value - 1) {
        $(this).attr("aria-pressed", "true");
      } else {
        $(this).attr("aria-pressed", "false");
      }
    });
  }

  function showThankYou() {
    $ratingIntro.addClass("d-none");
    $ratingIntroThankYou.removeClass("d-none");

    $ratingListWrapper.addClass("d-none");
    $ratingListThankYou.removeClass("d-none");
  }

  function showRating() {
    $ratingIntro.removeClass("d-none");
    $ratingIntroThankYou.addClass("d-none");

    $ratingListWrapper.removeClass("d-none");
    $ratingListThankYou.addClass("d-none");
  }

  // On load: if they've thanked before, show thank you (hide stars).
  // Otherwise show rating UI and ensure no stars are pre-filled.
  const hasThanked = !!localStorage.getItem(thankYouKey);

  if (hasThanked) {
    showThankYou();
  } else {
    showRating();
    updateStars($ul, 0);
  }

  // If there are no buttons, bail early
  if (!$buttons.length) return;

  // Hover / focus preview: light up all to the left (only if user hasn't rated)
  $buttons.on("mouseenter focus", function () {
    const rated = !!localStorage.getItem(thankYouKey);
    if (rated) return; // if they've already rated and we hid buttons, ignore
    const value = Number($(this).data("value")) || 0;
    $buttons.each(function (i) {
      $(this).toggleClass("hovered", i < value);
    });
  });

  // Clear preview on leave / blur (only if no selection yet)
  $buttons.on("mouseleave blur", function () {
    const rated = !!localStorage.getItem(thankYouKey);
    if (rated) return;
    const currentRating = Number($ul.data("rating")) || 0;
    if (currentRating === 0) {
      $buttons.removeClass("hovered");
    } else {
      // if there is a currentRating (rare in your flow), ensure hovered cleared
      $buttons.removeClass("hovered");
    }
  });

  // Click to save rating and show thank you
  $buttons.on("click", function () {
    const value = Number($(this).data("value")) || 0;
    if (!value) return;
    updateStars($ul, value);
    localStorage.setItem(ratingKey, String(value));
    localStorage.setItem(thankYouKey, "true");
    showThankYou();
    console.log("Saved rating:", value);
  });

  // Keyboard navigation + selection
  $buttons.on("keydown", function (e) {
    const currentIndex = $buttons.index(this);
    let newIndex = currentIndex;

    if (e.key === "ArrowRight" || e.key === "ArrowUp") {
      newIndex = Math.min(currentIndex + 1, $buttons.length - 1);
      e.preventDefault();
      $buttons.eq(newIndex).focus();
      return;
    }

    if (e.key === "ArrowLeft" || e.key === "ArrowDown") {
      newIndex = Math.max(currentIndex - 1, 0);
      e.preventDefault();
      $buttons.eq(newIndex).focus();
      return;
    }

    if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
      e.preventDefault();
      const value = currentIndex + 1;
      updateStars($ul, value);
      localStorage.setItem(ratingKey, String(value));
      localStorage.setItem(thankYouKey, "true");
      showThankYou();
      console.log("Saved rating by keyboard:", value);
      return;
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.getElementById('state-search-wrapper');
  const input   = document.getElementById('cb1-input');

  // If either element isn't present on this page, bail quietly.
  if (!wrapper || !input) return;

  const updateFloatingState = () => {
    const hasValueOrFocus =
      (input.value || '').trim() !== '' || document.activeElement === input;
    wrapper.classList.toggle('is-floating', hasValueOrFocus);
  };

  // Listeners (safe + lightweight)
  input.addEventListener('focus',  updateFloatingState, { passive: true });
  input.addEventListener('blur',   updateFloatingState, { passive: true });
  input.addEventListener('input',  updateFloatingState, { passive: true });

  // Catch programmatic value changes too
  const observer = new MutationObserver(updateFloatingState);
  observer.observe(input, { attributes: true, attributeFilter: ['value'] });

  // Initialize
  updateFloatingState();

  // Optional: clean up if your app swaps DOM chunks
  window.addEventListener('unload', () => observer.disconnect());
});


  //Strike "Morgan Health is" in footer
  $(".morganHealth p").text("a JPMorganChase business");

  // Transcript button functionality
  document.addEventListener('DOMContentLoaded', function() {
    const transcriptAccordion = document.getElementById('transcriptAccordion');
    const transcriptBtn = document.getElementById('transcriptBtn');
    
    if (transcriptAccordion && transcriptBtn) {
      transcriptAccordion.addEventListener('shown.bs.collapse', function() {
        transcriptBtn.setAttribute('aria-expanded', 'true');
      });
      
      transcriptAccordion.addEventListener('hidden.bs.collapse', function() {
        transcriptBtn.setAttribute('aria-expanded', 'false');
      });
    }
  });

  // Advisor detail tabs (Module 4)
  document.addEventListener('DOMContentLoaded', function () {
    const detail = document.getElementById('advisorDetail');
    if (!detail || typeof bootstrap === 'undefined' || !bootstrap.Tab) return;

    const activateAdvisorTab = function (tabKey, options) {
      if (!tabKey) return;
      const trigger = detail.querySelector(
        '.advisor-tabs [data-advisor-tab="' + tabKey + '"]'
      );
      if (!trigger) return;

      const tab = bootstrap.Tab.getOrCreateInstance(trigger);
      tab.show();

      if (options && options.scroll !== false) {
        detail.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      if (history.replaceState) {
        history.replaceState(null, '', '#' + tabKey);
      }
    };

    document.querySelectorAll('[data-advisor-tab]').forEach(function (el) {
      if (el.closest('.advisor-tabs')) return;

      el.addEventListener('click', function (event) {
        const tabKey = el.getAttribute('data-advisor-tab');
        if (!tabKey || !detail.querySelector('.advisor-tabs [data-advisor-tab="' + tabKey + '"]')) {
          return;
        }
        event.preventDefault();
        activateAdvisorTab(tabKey);
      });
    });

    detail.querySelectorAll('.advisor-tabs [data-advisor-tab]').forEach(function (btn) {
      btn.addEventListener('shown.bs.tab', function () {
        const tabKey = btn.getAttribute('data-advisor-tab');
        if (tabKey && history.replaceState) {
          history.replaceState(null, '', '#' + tabKey);
        }
      });
    });

    const hash = (window.location.hash || '').replace(/^#/, '');
    if (hash && detail.querySelector('.advisor-tabs [data-advisor-tab="' + hash + '"]')) {
      activateAdvisorTab(hash, { scroll: true });
    }
  });

  
  // Add Hub to older pages 
  const $navList = $('#navbarSupportedContent > ul.navbar-nav');

  // Check if the Health Care Hub link already exists
  const exists = $navList.find('a[href="/sb-health-care-hub/small-business-health-care-hub.htm"]').length > 0;

  if (!exists) {
    // Find the Portfolio link (we want to insert before it)
    const $portfolioItem = $navList.find('a[href="/portfolio.htm"]').closest('li.nav-item');

    // Build the new nav item
    const $healthHubItem = $(`
      <li class="nav-item">
        <a class="nav-link" href="/sb-health-care-hub/small-business-health-care-hub.htm">
          Health Care Hub<span class="rule"></span>
        </a>
      </li>
    `);

    // Insert before Portfolio (or at end if Portfolio is not found)
    if ($portfolioItem.length) {
      $healthHubItem.insertBefore($portfolioItem);
    } else {
      $navList.append($healthHubItem);
    }
  }


})(jQuery);
